import type { Options, Styles } from "react-joyride";

export const tourStyles: Partial<Styles> = {
  tooltip: {
    borderRadius: "var(--radius)",
    padding: "1.25rem",
    fontSize: "0.875rem",
    border: "1px solid hsl(var(--border))",
    boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
    // TES-1659: cap width + wrap long German labels so nothing overflows the
    // viewport. The floater already clamps to innerWidth-30 on narrow screens;
    // these caps keep the tooltip readable and prevent horizontal overflow.
    maxWidth: "min(320px, calc(100vw - 2rem))",
    boxSizing: "border-box",
    whiteSpace: "normal",
    overflowWrap: "break-word",
    wordBreak: "break-word",
  },
  tooltipTitle: {
    fontSize: "1rem",
    fontWeight: 600,
    marginBottom: "0.5rem",
    // TES-1659: long compound titles must wrap, never clip.
    whiteSpace: "normal",
    overflowWrap: "break-word",
    wordBreak: "break-word",
  },
  tooltipContent: {
    padding: "0.5rem 0 0",
    lineHeight: 1.6,
    // TES-1659: wrap long body copy + guard against horizontal overflow.
    whiteSpace: "normal",
    overflowWrap: "break-word",
    wordBreak: "break-word",
    overflowX: "hidden",
  },
  buttonPrimary: {
    backgroundColor: "hsl(var(--primary))",
    color: "hsl(var(--primary-foreground))",
    borderRadius: "calc(var(--radius) - 2px)",
    fontSize: "0.875rem",
    fontWeight: 500,
    padding: "0.625rem 1rem",
    outline: "none",
    transition: "color 150ms, background-color 150ms",
  },
  buttonBack: {
    color: "hsl(var(--muted-foreground))",
    fontSize: "0.875rem",
    fontWeight: 500,
    marginRight: "0.5rem",
    borderRadius: "calc(var(--radius) - 2px)",
    padding: "0.625rem 0.75rem",
    transition: "color 150ms, background-color 150ms",
  },
  buttonSkip: {
    color: "hsl(var(--muted-foreground))",
    fontSize: "0.8125rem",
    textUnderlineOffset: "4px",
  },
};

export const tourOptions: Partial<Options> = {
  arrowColor: "hsl(var(--popover))",
  backgroundColor: "hsl(var(--popover))",
  buttons: ["back", "primary", "skip"],
  overlayClickAction: false,
  overlayColor: "rgba(0, 0, 0, 0.5)",
  primaryColor: "hsl(var(--primary))",
  showProgress: true,
  spotlightRadius: 8,
  textColor: "hsl(var(--popover-foreground))",
  zIndex: 10000,
  // TES-1659: scroll defaults applied to EVERY step of both tours so the
  // highlighted element + tooltip are reliably brought fully into view.
  // scrollOffset leaves headroom above the target (cleared by the sticky
  // header); scrollDuration gives a smooth, deterministic scroll the E2E can
  // wait on. Per-step overrides (top-placement steps) layer on top of these.
  scrollOffset: 120,
  scrollDuration: 400,
};
